export const IconPencilEdit20: {
  name: 'icon_pencil_edit_20-bdeaa567bc43'
} = {
  name: 'icon_pencil_edit_20-bdeaa567bc43'
}
